import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=2dd766e2&scoped=true&lang=pug"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
import style0 from "~/assets/dashboard.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=2dd766e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd766e2",
  null
  
)

export default component.exports